import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Portuguese-Inspired Architecture",
    "Exclusive Jodi Flat Options Available",
    "Private Sundecks in Select Residences",
  ];
  const highlights2 = [
    "Landscaped Central Greens with Jogging Track",
    "Retail Spaces for Daily Conveniences",
    "Just 4-6 Apartments Per Floor",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Introducing The Address by GS Bandra, a Portuguese-inspired landmark by
        Raymond Realty in the prime location of Bandra East, Mumbai. Nestled
        across 3 acres of gated land, this residential marvel features 6
        majestic towers offering premium 2, 3, and 4 BHK residences, built with
        thoughtful planning, elegant aesthetics, and unmatched privacy.
        <br />
        With just 4 to 6 apartments per floor and exclusive Jodi flat options,
        The Address by GS Bandra offers a rare blend of spacious design and
        sophisticated architecture. From sundecks and cabanas to a serene
        library and jogging track, this project redefines luxury for modern
        Mumbaikars seeking peace in the city's heart.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
